import '@App/configs/zod-config'

import pkg from './../package.json'
import React from 'react'
import './index.scss'
import { initializeGoogleConsent } from '@App/configs/google-consent-config'
import { initializeGtm } from '@App/configs/google-tag-manager-config'
import { configureMobX } from '@App/configs/mobx-config'
import configureDayjs from '@App/configs/dayjs-config'
import { RouterProvider } from 'react-router'
import createRouter from '@App/routes'
import RootStore from '@App/stores/root-store'
import { StoresContext } from '@App/contexts'
import { createRoot } from 'react-dom/client'
import { createPortal } from 'react-dom'
import { QueryClientProvider } from '@tanstack/react-query'
import { appQueryClient } from '@App/configs/query-client'

configureMobX()
configureDayjs()

const router = createRouter()
const rootStore = new RootStore(router)
const queryClient = appQueryClient

const container = document.getElementById('root')
const root = createRoot(container!)

module.hot?.accept()

initializeGoogleConsent()
initializeGtm(window, document, 'script', 'dataLayer', 'GTM-KKSPCF4')

root.render(
    <>
        {createPortal(
            <>
                {/* Cookiebot CMP */}
                <script
                    id="Cookiebot"
                    src="https://consent.cookiebot.com/uc.js"
                    data-cbid={window.APP_CONFIG.COOKIE_BOT_CBID}
                    data-blockingmode="auto"
                    type="text/javascript"
                    async
                />
            </>,
            document.head
        )}
        {/* QA Only env variable for external testing service. */}
        <meta name="insight-app-sec-validation" content={window.APP_CONFIG.INSIGHT_APP_SEC_APP_ID} />
        <QueryClientProvider client={queryClient}>
            <StoresContext.Provider value={rootStore}>
                <RouterProvider router={router} />
            </StoresContext.Provider>
        </QueryClientProvider>
    </>
)

// eslint-disable-next-line no-console
console.log('FE-Version: ' + pkg.version)
